import { Shield } from 'lucide-react'

import { Badge } from '../../components/ui'

export function AdminMarker() {
  return <Badge tone="warning"><Shield size={12} aria-hidden="true" /> Admin</Badge>
}
